import { useQuery } from "@tanstack/react-query"
import { client } from "@/api"

export interface DetectJob {
  job_id: string
  status: string
  progress: string | null
  frame_count: number | null
  updated_at: string
  email: string | null
  error: string | null
}

export type DetectJobStatusFilter = "all" | "running"

interface UseDetectJobsOptions {
  limit?: number
  status?: DetectJobStatusFilter
  enabled?: boolean
}

export function useDetectJobs({
  limit = 50,
  status = "all",
  enabled = true,
}: UseDetectJobsOptions = {}) {
  return useQuery<DetectJob[]>({
    queryKey: ["admin", "detect-jobs", { limit, status }],
    queryFn: async () => {
      const response = await client.admin["detect-jobs"].$get({
        query: {
          limit: limit.toString(),
          status,
        },
      })

      if (!response.ok) {
        throw new Error(`Failed to fetch detect jobs: ${response.status}`)
      }

      return response.json() as Promise<DetectJob[]>
    },
    enabled,
    // No refetchIntervalInBackground (2026-09-28 incident): installIdlePause
    // (@playside/tab-activity) already pauses this while the tab is hidden or idle.
    refetchInterval: 4000,
  })
}
